// extracted by mini-css-extract-plugin
export default {"button":"FeedbackButton_button__Jdlp1"};